import { EntityService } from '@/services/EntityService';

export class RelatedCompaniesService extends EntityService {
  static get entity() {
    return 'related-companies';
  }
}
